"use client";

type GradeBlobPillProps = {
  label: string;
  active: boolean;
  onClick: () => void;
};

export function GradeBlobPill({ label, active, onClick }: GradeBlobPillProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={`relative inline-flex items-center justify-center charlie-kingdom-font text-brand-blue-deep text-5xl md:text-6xl px-10 py-4 transition-opacity ${
        active ? "" : "opacity-25 hover:opacity-60"
      } focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-black/20`}
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 bg-[url('/images/marketing/educators/greatGames/blob.svg')] bg-center bg-contain bg-no-repeat"
      />
      <span className="relative">{label}</span>

      {active && (
        <svg
          aria-hidden="true"
          className="absolute left-1/2 -translate-x-1/2 -bottom-9 w-16 h-8"
          viewBox="0 0 40 24"
          preserveAspectRatio="none"
          fill="none"
        >
          <path d="M20 0L40 24H0L20 0Z" style={{ fill: "rgb(var(--cta-gold))" }} />
        </svg>
      )}
    </button>
  );
}
